import { Stack } from '@mui/material';
import React, { PropsWithChildren, useRef, useEffect } from 'react';
import styled from 'styled-components';

interface Props {
  open: boolean;
  onClose: () => void;
}

function WdbModal({ open, children, onClose }: PropsWithChildren<Props>) {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    }

    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <Wrapper ref={wrapperRef} gap="14px" width="75%">
      <Stack direction="row" justifyContent="flex-end">
        <CloseIcon onClick={onClose} />
      </Stack>
      {children}
    </Wrapper>
  );
}

export default WdbModal;

const CloseIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      onClick={onClick}
    >
      <path d="M1 1L17 17" stroke="#777777" strokeWidth="2" />
      <path d="M1 17L17 1" stroke="#777777" strokeWidth="2" />
    </svg>
  );
};

const Wrapper = styled(Stack)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 4px 20px 0px rgba(0, 30, 81, 0.12),
    0px 0px 8px 0px rgba(0, 30, 81, 0.04);
  padding: 20px 16px;
  z-index: 999;
`;
